import { useLanguage } from "@/lib/i18n";

interface Step {
  step: number;
  title: string;
  description: string;
  image?: string;
}

interface HowToUseSectionProps {
  steps: Step[];
  title?: string;
}

export function HowToUseSection({ steps, title }: HowToUseSectionProps) {
  const { t } = useLanguage();
  
  return (
    <section className="mb-8 md:mb-10">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-5 md:mb-7">
        {title || t('product.howToUse')}
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
        {steps.map((step) => (
          <div key={step.step} className="text-center p-4 md:p-6 bg-white/70 rounded-2xl border border-white/80 shadow-sm">
            {step.image ? (
              <div className="w-16 h-16 md:w-20 md:h-20 mx-auto mb-3 md:mb-4 rounded-2xl overflow-hidden">
                <img src={step.image} alt={step.title} className="w-full h-full object-cover" />
              </div>
            ) : (
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 md:mb-4 rounded-full bg-primary/10 flex items-center justify-center">
                <span className="text-lg md:text-xl font-bold text-primary">{step.step}</span>
              </div>
            )}
            <h3 className="font-semibold text-sm md:text-base mb-1 md:mb-2">{step.title}</h3>
            <p className="text-xs md:text-sm text-muted-foreground leading-relaxed">{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
